import { objectSchema } from "vue-utils"
import type { INamed, IncidentEntity } from "../IncidentEntity"

export interface VtsRemarkTemplate extends IncidentEntity, INamed {}

export const VtsRemarkTemplate = objectSchema<VtsRemarkTemplate>({
	id: Number,
	name: String,
})
